var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
function StepPasswordForm(_a) {
    var onSubmit = _a.onSubmit;
    var _b = useState(''), password = _b[0], setPassword = _b[1];
    var _c = useState(''), passwordRepeat = _c[0], setPasswordRepeat = _c[1];
    var _d = useState(false), showPassword = _d[0], setShowPassword = _d[1];
    var _e = useState(false), showPasswordRepeat = _e[0], setShowPasswordRepeat = _e[1];
    var _f = useState({
        password: '',
        passwordRepeat: '',
    }), errors = _f[0], setErrors = _f[1];
    var _g = useState({
        password: false,
        passwordRepeat: false,
    }), touched = _g[0], setTouched = _g[1];
    var validatePassword = function (value) {
        if (value.length === 0)
            return '';
        if (value.length < 8) {
            return 'A senha deve ter pelo menos 8 caracteres';
        }
        return '';
    };
    var validatePasswordRepeat = function (value, passwordValue) {
        if (value.length === 0)
            return '';
        if (value !== passwordValue) {
            return 'Suas senhas não correspondem.';
        }
        return '';
    };
    var handlePasswordChange = function (e) {
        var value = e.target.value;
        setPassword(value);
        if (touched.password) {
            setErrors(function (prev) { return (__assign(__assign({}, prev), { password: validatePassword(value) })); });
        }
        if (touched.passwordRepeat && passwordRepeat.length > 0) {
            setErrors(function (prev) { return (__assign(__assign({}, prev), { passwordRepeat: validatePasswordRepeat(passwordRepeat, value) })); });
        }
    };
    var handlePasswordRepeatChange = function (e) {
        var value = e.target.value;
        setPasswordRepeat(value);
        if (touched.passwordRepeat) {
            setErrors(function (prev) { return (__assign(__assign({}, prev), { passwordRepeat: validatePasswordRepeat(value, password) })); });
        }
    };
    var handlePasswordBlur = function () {
        setTouched(function (prev) { return (__assign(__assign({}, prev), { password: true })); });
        setErrors(function (prev) { return (__assign(__assign({}, prev), { password: validatePassword(password) })); });
    };
    var handlePasswordRepeatBlur = function () {
        setTouched(function (prev) { return (__assign(__assign({}, prev), { passwordRepeat: true })); });
        setErrors(function (prev) { return (__assign(__assign({}, prev), { passwordRepeat: validatePasswordRepeat(passwordRepeat, password) })); });
    };
    var handleSubmit = function (e) {
        e.preventDefault();
        setTouched({ password: true, passwordRepeat: true });
        var passwordError = validatePassword(password);
        var passwordRepeatError = validatePasswordRepeat(passwordRepeat, password);
        setErrors({
            password: passwordError,
            passwordRepeat: passwordRepeatError,
        });
        if (passwordError || passwordRepeatError) {
            return;
        }
        onSubmit({ password: password, password_repeat: passwordRepeat });
    };
    return (_jsxs("div", __assign({ className: "box-welcome" }, { children: [_jsx("h2", { children: "Crie uma senha segura" }), _jsx("p", { children: "Sua senha garante que s\u00F3 voc\u00EA tenha acesso ao seu portal CeletiHub." }), _jsxs("form", __assign({ onSubmit: handleSubmit }, { children: [_jsxs("div", __assign({ className: "step-box form-step" }, { children: [_jsx("label", { children: "Senha" }), _jsxs("div", __assign({ style: { position: 'relative' } }, { children: [_jsx("input", { type: showPassword ? 'text' : 'password', value: password, onChange: handlePasswordChange, onBlur: handlePasswordBlur, className: "form-control", placeholder: "**********" }), _jsx("button", __assign({ type: "button", onClick: function () { return setShowPassword(!showPassword); }, style: {
                                            position: 'absolute',
                                            right: '12px',
                                            top: '50%',
                                            transform: 'translateY(-50%)',
                                            background: 'none',
                                            border: 'none',
                                            cursor: 'pointer',
                                            padding: '4px',
                                            fontSize: '18px',
                                        } }, { children: showPassword ? (_jsx(VisibilityOffOutlinedIcon, {})) : (_jsx(VisibilityOutlinedIcon, {})) }))] })), errors.password && (_jsx("small", __assign({ className: "error-text" }, { children: errors.password }))), _jsx("label", { children: "Confirmar senha" }), _jsxs("div", __assign({ style: { position: 'relative' } }, { children: [_jsx("input", { type: showPasswordRepeat ? 'text' : 'password', value: passwordRepeat, onChange: handlePasswordRepeatChange, onBlur: handlePasswordRepeatBlur, className: "form-control", placeholder: "**********" }), _jsx("button", __assign({ type: "button", onClick: function () {
                                            return setShowPasswordRepeat(!showPasswordRepeat);
                                        }, style: {
                                            position: 'absolute',
                                            right: '12px',
                                            top: '50%',
                                            transform: 'translateY(-50%)',
                                            background: 'none',
                                            border: 'none',
                                            cursor: 'pointer',
                                            padding: '4px',
                                            fontSize: '18px',
                                        } }, { children: showPasswordRepeat ? (_jsx(VisibilityOffOutlinedIcon, {})) : (_jsx(VisibilityOutlinedIcon, {})) }))] })), errors.passwordRepeat && (_jsx("small", __assign({ className: "error-text" }, { children: errors.passwordRepeat })))] })), _jsx("div", __assign({ className: "box-first-access-button" }, { children: _jsx("button", __assign({ type: "submit", className: "btn-first-access" }, { children: "Continuar" })) }))] }))] })));
}
export default StepPasswordForm;
